export const SET_ERROR = 'SET_ERROR';
export const SET_ERROR_STATUS = 'SET_ERROR_STATUS';
export const SET_ERROR_STATUS_TEXT = 'SET_ERROR_STATUS_TEXT';
export const SET_ERROR_OPTIONS = 'SET_ERROR_OPTIONS';

export default {
    SET_ERROR,
    SET_ERROR_STATUS,
    SET_ERROR_STATUS_TEXT,
    SET_ERROR_OPTIONS,
};